import { gql } from 'graphql-request'
import { createQuery } from '@fivehealth/botero'

const UPDATE_HOSPITAL_FAVORITE_GRAPHQL_DOCUMENT = gql`
  mutation einsteinFavouriteUpdate($input: UpdateHospitalFavouriteInput!) {
    hospitalFavouriteUpdate(input: $input) {
      hospitalFavourite {
        key
        title
        subtitle
        url
        hospital {
          organizationKey
        }
      }
    }
  }
`

export default createQuery({
  gqlDocument: UPDATE_HOSPITAL_FAVORITE_GRAPHQL_DOCUMENT,
  queryType: 'mutation',
  baseQueryKey: 'updateHospitalFavorite',
  keepPreviousData: true,
  allowErrorResponse: true,
})
